import React from "react";

const UIUXDevBanner = () => {
  return (
    <div
      className="inner_banner service-banner"
      style={{ backgroundImage: "url(/assets/images/site/uiux-banner.png)" }}
    >
      <div className="wrapper">
        <div className="banner_detail_1">
          <div className="details-ser">
            <h1 id="heading_line">UI / UX</h1>
            <h2 id="sub_heading1">
            A great design is about more than aesthetics it’s about creating meaningful interactions while showcasing your unique brand identity. At Codeflix Web LLC, we combine UI/UX design expertise with branding strategies to ensure your digital products captivate users and reinforce your business identity.

            </h2>
          </div>
          <div className="arrows">
            <img src="/assets/images/new/arrows-ser.svg" alt="arrows" />
          </div>
          <div className="slider-block">
            <img src="/assets/images/new/sercive_banner.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UIUXDevBanner;
